export default __webpack_public_path__ + "static/media/radio.4b03c038.svg";